import React, { useEffect, FC, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import EventTicket from '../../../images/event-ticket.png';
import ProductSlider from './Helpers/ProductSlider';
import {
  getRaffleGroup,
  getUserRaffleTickets,
  getRafflesToday,
} from '../../../actions/kafairAction';
import { connect } from 'react-redux';
import Slider from "react-slick"
import SliderLeftHovered from '../../../images/left-black-arrow-3.png';
import SliderRightHovered from '../../../images/right-black-arrow-3.png';
import ArrowBlackRight from '../../../images/arrow-black-right.png';
import ArrowBlackLeft from '../../../images/arrow-black-left.png';
import HotProduct from '../../../images/fire-product.png';
import { getCloudImageUrl, emptyImage } from '../../../utils/Helpers';
import { TextRupiah } from '../../Text';
import emptySneakerImg from '../../../images/emptysneakers2.png';
import emptyApparelImg from '../../../images/emptyapparels.png';
import emptyHandbagImg from '../../../images/emptyhandbags.png';
import styled from 'styled-components';
import { useHistory, Link } from "react-router-dom";

// Helpers to convert hex to RGBA
import { convertHexToRGBA } from "../../../helpers/color"

interface PreviousSlide {
  className: string;
  style: Object;
  onClick: () => any;
}

interface NextSlide {
  className: string;
  style: Object;
  onClick: () => any;
}

const PrevSlide = (props: PreviousSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      left: 10px !important;
      position: absolute;
      object-fit: contain;
    }
    @media (max-width: 480px) {
      img {
        width: 30px !important;
        height: 30px !important;
        position: absolute;
        left: -5px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        left: '40px !important',
        width: '40px',
        height: '40px',
        display: window.screen.availWidth < 640 ? 'none' : 'block',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackLeft : SliderLeftHovered} alt="..." />
    </LeftArrow>
  );
};

const NextSlide = (props: NextSlide) => {
  const { className, style, onClick } = props;
  const [hovered, setHoveredLeft] = useState(false);

  function handleHover() {
    setHoveredLeft(!hovered);
  }

  const LeftArrow = styled.div`
    &::before {
      content: '';
    }
    img {
      width: 40px !important;
      height: 40px !important;
      object-fit: contain;
      right: -90px;
      position: absolute;
    }
    @media (max-width: 480px) {
      img {
        right: 5px;
        width: 30px !important;
        height: 30px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{
        ...style,
        display: window.screen.availWidth < 640 && 'none',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      <KickImage src={hovered ? ArrowBlackRight : SliderRightHovered} alt="..." />
    </LeftArrow>
  );
};
interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

interface RaffleGroup {
  query: string;
  ticket_type: string;
  title: string;
}

type RaffleSection = {
  history: History;
  category: string;
  getCollectionList: (
    args: string,
    slug: string,
    payload: Object,
    name: string,
  ) => any;
  dataFlashSale: Array<Object>;
  raffleGroup: Array<RaffleGroup>;
  getRafflesToday: (args: string) => any;
  ticket_type: string;
  query: string;
  color: string;
  raffleTitle: string;
  ticket: string;
  getUserRaffleTickets: () => any;
  raffle: Array<Object>;
  isLogged: boolean;
};

const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: <PrevSlide />,
  nextArrow: <NextSlide />,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}

const RaffleSection: FC<RaffleSection> = ({
  category,
  raffle,
  getUserRaffleTickets,
  getRafflesToday,
  ticket,
  raffleTitle,
  query,
  ticket_type,
  isLogged,
  color: raffleCollor
}) => {
  const [products, setProducts] = useState([]);
  const [userTicket, setUserTicket] = useState(null);
  const [bgColor, setBackgroundColor] = useState('');
  const [ticketImageUrl, setTicketImageUrl] = useState('');
  const [color, setColor] = useState("");
  let history = useHistory();

  // First Parameter = hexcode, Second Parameter = opacity => 0.1 = 10%
  useEffect(() => {
    backgroundColorConverter(color, 0.1)
  }, [color])

  // Convert color from hexcode to rgba for background color => asynchronous task
  async function backgroundColorConverter(defaultColor, opacity) {
    let data = await convertHexToRGBA(defaultColor, opacity)
    if (data) {
      setBackgroundColor(data)
      return data
    } else {
      return;
    }
  }

  // Get current active raffle and user raffle's ticket
  useEffect(() => {
    getRafflesToday(query)
      .then((_) => {
        return getUserRaffleTickets();
      })
      .catch((e: string) => console.log(e));
  }, [query]);

  // Set user raffle ticket from reducer to state
  useEffect(() => {
    if (ticket[ticket_type]) {
      setUserTicket(ticket[ticket_type].total);
      setTicketImageUrl(ticket[ticket_type].ticket_img_url);
      setColor(ticket[ticket_type].color);
    }
  }, [ticket]);

  // Set raffle products
  useEffect(() => {
    if (
      raffle &&
      query &&
      raffle[query]
    ) {
      setProducts(raffle[query].products);
    }
  }, [raffle]);

  // Redirect onClick view all slider
  function goToPage() {
    history.push(`/${category}/raffle/${query}`);
  }

  //Redner Title
  const renderTitle = () => {
    if (!raffleTitle) {
      return <p></p>
    }

    if (typeof raffleTitle !== 'string') {
      return <p></p>
    }

    const splitedTitle = raffleTitle.split(" ")
    if (splitedTitle.length === 0 || !splitedTitle) {
      return <p></p>
    }

    const blackColoredTitle = splitedTitle.filter((_, idx) => idx > 0)
    let blackColoredTitleString = ''
    if (blackColoredTitle.length > 0) {
      blackColoredTitleString = blackColoredTitle.join(" ")
    }

    return <p style={{ color: "#242424" }}><span style={{ color: raffleCollor ? raffleCollor : "#242424", }}>{splitedTitle[0]}</span> {blackColoredTitleString}</p>
  }

  // Redirect on click slide
  function onClickItem(url: string) {
    history.push(url);
  }

  // Display raffle if products is not empty in sneakers category
  if (products.length <= 0) return null

  // Mobile view render
  if (window.screen.availWidth < 480) {
    // Display slider on mobile screen
    return (
      <div style={{ padding: "0px" }} className="KickFair-v3">
        <div style={{ padding: "0px 20px" }} className="KickFairV3-Header">
          <div className="KickFairV3-Title" style={!isLogged ? { display: "flex", justifyContent: "space-between", alignItems: "center" } : {}}>
            {/* <p style={{ color: color ? color : "#242424", }}>{raffleTitle}</p> */}
            {renderTitle()}
            {
              !isLogged &&
              <div className="KickFairV3-View">
                <Link target={"_blank"} to={`/${category}/raffle/${query}`}>
                  <p>View Raffles</p>
                </Link>
              </div>
            }
          </div>
          <div className="KickFairV3__Desc">
            {
              isLogged ?
                <div style={{ backgroundColor: bgColor }} className="tickets">
                  <KickImage src={getCloudImageUrl(ticketImageUrl, 100)} alt="Event ticket" />
                  <p style={{ color: color }}>
                    {userTicket}
                  </p>
                </div> : <div></div>
            }
            {
              isLogged &&
              <div className="KickFairV3-View">
                <Link target={"_blank"} to={`/${category}/raffle/${query}`}>
                  <p>View Raffles</p>
                </Link>
              </div>
            }
          </div>
        </div>
        <div className="KickFairV3-Main">
          {products && products.length > 0 && (
            <ProductSlider isRaffle dataProducts={products} history={history}
              chosenOption={raffleTitle} query={query}
            />
          )}
        </div>
      </div>
    );
  }

  interface ItemProducts {
    display_name: string;
    id: number;
    editors_choice: boolean;
    image: string;
    price: number;
    vintage: boolean;
    category: string;
  }

  // Display slider on desktop screen
  return (
    <div className="KickFair-v3">
      <div className="KickFairV3-Header">
        <div className="KickFairV3-Title">
          {/* <p style={{ color: color ? color : "#242424", }} >{raffleTitle}</p> */}
          {renderTitle()}
          {
            isLogged ?
              <div style={{ backgroundColor: bgColor }} className="ticket-information">
                <KickImage src={getCloudImageUrl(ticketImageUrl, 100)} alt="Event ticket" />
                <p style={{ color: color }}>
                  {userTicket}
                </p>
              </div> : <div></div>
          }
        </div>
        <div className="KickFairV3-Ticket">
          <Link target={"_blank"} to={`/${category}/raffle/${query}`}>
            <p>View Raffles</p>
          </Link>
        </div>
      </div>
      <div className={`KickFairV3-Main ${products?.length < 4 ? "center-content" : ""}`}>
        {products && products.length > 0 && (
          <Slider {...settings}>
            {
              products && products.map((item: ItemProducts) => {
                const brand = item && item.brand;
                const categoryName = item && item.product && item.product.category && item.product.category.name;
                return (
                  <div
                    key={item.id}
                    className="homepage-product__section"
                  >
                    <Link
                      target={"_blank"}
                      to={`/${category}/raffle/${query}`}>
                      <div
                        style={{
                          position: item.editors_choice && 'relative',
                        }}
                        className="homepage-product__container"
                      >
                        {item.editors_choice && (
                          <KickImage
                            className="isHotProduct"
                            src={HotProduct}
                            alt="hot product"
                          />
                        )}
                        <KickImage
                          className="homepage-product__img"
                          src={
                            item.image
                              ? getCloudImageUrl(item.image, 500)
                              : emptyImage(item.category)
                          }
                          alt=""
                        />
                        {
                          categoryName === "handbags" ?
                          <p className="homepage-product__brand">{brand.flat.length > 0 ? brand.flat[0] : brand.name}</p> : null
                        }
                        <p className="homepage-product__name">{item.display_name}</p>
                        <p
                          style={{ color: '#159953' }}
                          className="homepage-product__price"
                        >
                          {item.price ? (
                            <TextRupiah
                              currency="IDR. "
                              color="#159953"
                              align="right"
                              value={item.price && item.price.toString()}
                            />
                          ) : <span style={{ color: "red" }}>Out of stock</span>
                          }
                        </p>
                      </div>
                    </Link>
                  </div>
                )
              })
            }
            {/* {products.length > 0 && (
          <Link target="_blank" to={`/${category}/raffle/${query}`} className="homepage-lastSlide">
            <div
              style={{
                border: '1px solid #e0e0e0',
                width: '260px',
                marginRight: 'auto',
                marginLeft: 'auto'
              }}
              className="homepage-showAll"
            >
              <h4
                style={{
                  color: '#242424',
                  paddingLeft: '0px',
                }}
              >
                View All
              </h4>
              <p style={{ color: '#242424' }}>
                {raffleTitle}
              </p>
            </div>
          </Link>
        )} */}
          </Slider>
        )}
      </div>
    </div >
  );
};

interface Data {
  data: Array<Object>;
}

interface TicketData {
  data: Object;
}

interface FlashSale {
  flashSale: Data;
  raffle: any;
  raffleGroup: Data;
  userRaffleTicket: TicketData;
}

interface IsLogged {
  isLogged: boolean;
}
interface State {
  dataKaFair: FlashSale;
  dataAuth: IsLogged;
}

const mapStateToProps = (state: State) => ({
  raffle: state.dataKaFair.raffle,
  raffleGroup: state.dataKaFair.raffleGroup.data,
  ticket: state.dataKaFair.userRaffleTicket.data,
  isLogged: state.dataAuth.isLogged
});

const mapDispatchToProps = (dispatch: any) => ({
  getUserRaffleTickets: () => dispatch(getUserRaffleTickets()),
  getRaffleGroup: () => dispatch(getRaffleGroup()),
  getRafflesToday: (group_name: string) =>
    dispatch(getRafflesToday(group_name)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RaffleSection);
